import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Header, Input, Grid, Menu, Divider, Card, Icon, Button, Accordion, AccordionContent } from 'semantic-ui-react';

import { Filters } from '../search/Filters';
import { Result } from '../search/Result';
import { ResultsContainer } from '../search/ResultsContainer';
import { FilterInstructions } from '../search/Filterinstructions';

export const SearchResults = () => {
  const size = 90;
  const [aliases, setAliases] = useState({});
  //const [query, setQuery] = useState('*');
  const [optAggs, setOptAggs] = useState({});
  const [query, setQuery] = useState('*');
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(size);
  const [activeTab, setActiveTab] = useState('song_cycles');
  const params = useQuery();
  const tabs = [
    { index: 'song_cycles', name: 'Song Cycles', icon: 'book', color: 'yellow' },
    { index: 'songs', name: 'Songs', icon: 'music', color: 'green' },
    { index: 'composers', name: 'Composers', icon: 'user', color: 'blue' },
    { index: 'text_authors', name: 'Text Authors', icon: 'quote left', color: 'orange' }
  ];

  function useQuery () {
    return new URLSearchParams(useLocation().search);
  }

  function handleChange(event) {
    //const val = event.target.value;
    //setQuery(prev => ({ //New setQuery to accomodate optional arguments for filters
      //...prev,
      //text: val
    //}));
    setQuery(event.target.value);
  }

  function handleTabClick(event, target) {
    const { name } = target;
    setActiveTab(name);
  }

  async function getAliases() {
    const result = await fetch('/es/_cat/aliases?format=json');
    const json = await result.json();
    let out = {};
    json.forEach(a => {
      out[a.index] = a.alias;
    });
    setAliases(out);
  }

  useEffect(() => {

    // reload page for the weird error on songs after voice type was introduced 

  const hasReloaded = sessionStorage.getItem('searchResultsReloaded');

  if (!hasReloaded) {
    sessionStorage.setItem('searchResultsReloaded', 'true');
    window.location.reload();
    return; 
  }
  
    // get aliases
    getAliases();

    // get query param from URL
    let q = params.get('q');
    q = !!q && !!q.length ? q : '*';

    setQuery(q);

    // handle pagination
    let start = params.get('start');
  }, []);

  const menuItems = tabs.map((t, i) => {
    return (
      <Menu.Item name={t.index} active={activeTab === t.index} onClick={handleTabClick} key={i}>
        <Icon name={t.icon} color={t.color} /> {t.name}
      </Menu.Item>
    )
  });

  const [instructionsOpen, setInstructionsOpen] = useState(false);
  
  const instructionsButton = (
    <Button basic icon labelPosition="left">
      <Icon name="info circle" />
      Usage Guidelines
    </Button>
  );

  const instructionsModal = (
    <FilterInstructions
      openButton={instructionsButton}
    />
  );

  return (
    <Container className='view-container'>
      <Header as='h1' className='title' size='huge'>Search our Collections</Header>
      <Divider />

      <div style={{ textAlign: 'center' }}>

        <Accordion styled style={{ width: '75%', margin: '0 auto' }}>
          <Accordion.Title
            active={instructionsOpen}
            onClick={() => setInstructionsOpen(!instructionsOpen)}
          >
            <Icon name={instructionsOpen ? 'chevron up' : 'chevron down'} />
            Filter Instructions
          </Accordion.Title>

          <Accordion.Content active={instructionsOpen}>
            <Header as="h4">
              Instructions for Filter Testing v3.0
            </Header>

            <p>
              Use the search bar below to enter your query & use the tabs below to
              search among our 4 collections. Here are a couple of tips to help you
              on your search!!
            </p>

            <ul style={{ textAlign: 'left' }}>
              <li>
                <strong>Open Filters</strong> - to open the filters sidebar click
                the Show Filters button.
              </li>

              <li>
                <strong>Categorical filters</strong> - The gender, language,
                instrumentation, and voice type filters can be used by clicking and
                selecting multiple options. In addition you can click them a second
                time to deselect them.
              </li>

              <li>
                <strong>Date Fields</strong> - To use the date fields start with
                filling out the start date. Then you will see the selected start date
                appear in grey below both boxes. Once that is done you can select the
                end date and toggle +/- 1 year on the arrows on the right hand side.
              </li>

              <li>
                <strong>What do I do when No Results are Found?</strong> - It is very
                possible that when toggling between songs and composers you lose your
                results because it is searching for the same filters you input before.
                If this happens please refresh the page and click to your desired tab
                again.
              </li>

              <li>
                <strong>Reset Filters</strong> - To reset all filters, click the
                "Reset Filters" button in the filters sidebar.
              </li>
            </ul>
          </Accordion.Content>
        </Accordion>
      </div>

      <Divider />
      <Input className='search-main' fluid size='large' icon='search' placeholder='Search' value={query} autoFocus={true} onChange={handleChange} />
      
      <Menu tabular attached='top'>
        {menuItems}
      </Menu>
      <ResultsContainer query={query} setQuery={setQuery} optAggs={optAggs} setOptAggs={setOptAggs} model={activeTab} aliases={aliases} start={start} end={end} size={size} />
      {/* <Grid>
        <Grid.Column width={3}>
          <Filters aggs={aggs} aliases={aliases} />
        </Grid.Column>
        <Grid.Column width={13}>
          <Header as='h4' color='grey' className='subtitle'>Showing {start + 1} - {end} of {total} results</Header>
          <Divider />
          <Menu tabular>
            <Menu.Item link active><Icon name='book' color='yellow'></Icon> Song Cycles &amp; Collections</Menu.Item>
            <Menu.Item link color='green'><Icon name='music' color='green'></Icon>Songs</Menu.Item>
            <Menu.Item link color='blue'>Composers</Menu.Item>
            <Menu.Item link color='orange'>Text Authors</Menu.Item>
          </Menu>
          <Card.Group itemsPerRow={3}>
            {results}
          </Card.Group>
        </Grid.Column>
      </Grid> */}
    </Container>
  );
};
